'use strict';

import { assetUrl } from '../utils/assets';

// Stands in for a rewarded ad AdSense did not fill (#137): a static Game8 card
// with a countdown, after which the player gets the reward they asked for.
//
// Appended to document.body, the same place AdSense puts its own overlay.
// GameScreen fullscreens the whole document rather than the game container
// for exactly that reason, so this stays visible in fullscreen too.
//
// Closes itself when the countdown ends instead of waiting for a click: a
// player who looks away must still get the reward and the game back, and the
// ad flow above has a deadline of its own that a click-to-close could outlast.
export function showPromoBanner(options) {
  const seconds = options.seconds;
  const onDone = options.onDone;

  const overlay = document.createElement('div');
  overlay.className = 'g8plugin-promo';
  overlay.setAttribute('role', 'dialog');
  overlay.setAttribute('aria-modal', 'true');
  overlay.setAttribute('aria-label', 'Game8');

  const card = document.createElement('div');
  card.className = 'g8plugin-promo__card';

  const logo = document.createElement('img');
  logo.className = 'g8plugin-promo__logo';
  logo.src = assetUrl('logo.png');
  logo.alt = '';

  const title = document.createElement('div');
  title.className = 'g8plugin-promo__title';
  title.textContent = 'Game8.io';

  const subtitle = document.createElement('div');
  subtitle.className = 'g8plugin-promo__subtitle';
  subtitle.textContent = 'Thousands of free games, no download needed';

  const status = document.createElement('div');
  status.className = 'g8plugin-promo__status';
  status.setAttribute('aria-live', 'polite');
  const count = document.createElement('span');
  count.className = 'g8plugin-promo__count';
  status.append('Your reward arrives in ', count, 's');

  card.append(logo, title, subtitle, status);
  overlay.appendChild(card);

  let left = seconds;
  let done = false;
  count.textContent = String(left);

  const finish = function () {
    if (done) return;
    done = true;
    clearInterval(timer);
    overlay.remove();
    onDone();
  };

  // Attach first, start counting second. The caller treats a throw from here as
  // "no banner" and reports the break as failed; a timer started before a
  // failing appendChild would still pay the reward out five seconds later, and
  // the game would hear both.
  document.body.appendChild(overlay);

  const timer = setInterval(function () {
    left -= 1;
    if (left <= 0) finish();
    else count.textContent = String(left);
  }, 1000);
}
